import * as React from 'react';
export var DropdownMenuContext = React.createContext({
    size: 'default',
    onSelectItem: function () { return undefined; },
});
export var useDropdownMenuContext = function () { return React.useContext(DropdownMenuContext); };
